import React, { useEffect, useState } from 'react';
export const HomePage: React.FC = () => {
  const [firstQuoteOpacity, setFirstQuoteOpacity] = useState(0);
  const [firstQuoteScale, setFirstQuoteScale] = useState(0.8);
  const [secondQuoteOpacity, setSecondQuoteOpacity] = useState(0);
  const [secondQuoteScale, setSecondQuoteScale] = useState(0.8);
  const [imageScale, setImageScale] = useState(1.08);
  const [imageOpacity, setImageOpacity] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  const quotes = [{
    text: ['„Erfolgreiche Veränderung', 'bedeutet, Stärken zu', 'kennen und gezielt', 'einzusetzen."']
  }, {
    text: ['„Coaching &', 'Beratung bei', 'wandelwert bringt', 'Ihre Potenziale auf', 'den Punkt."']
  }];
  useEffect(() => {
    if (!imageLoaded) return;
    // Start fade-in immediately after image loads
    setImageOpacity(1);
    // Start first quote animation
    const firstQuoteTimer = setTimeout(() => {
      setFirstQuoteOpacity(1);
      setFirstQuoteScale(1);
    }, 500);
    // Start scaling animation after fade-in begins
    const scaleTimer = setTimeout(() => {
      setImageScale(1);
    }, 300);
    // Start quote fade animation
    const fadeTimer = setTimeout(() => {
      setFirstQuoteOpacity(0);
      setFirstQuoteScale(0.8);
      setTimeout(() => {
        setSecondQuoteOpacity(1);
        setSecondQuoteScale(1);
      }, 500);
    }, 4000);
    return () => {
      clearTimeout(firstQuoteTimer);
      clearTimeout(scaleTimer);
      clearTimeout(fadeTimer);
    };
  }, [imageLoaded]);
  const handleImageLoad = () => {
    setImageLoaded(true);
  };
  return <section className="w-full bg-white relative overflow-hidden min-h-screen" data-id="element-338">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vJayhFPSBCKSCgLEmUVrQG/start.jpg" alt="Eva Schifferer" className="w-full h-screen object-cover transition-all duration-[3500ms] ease-out" onLoad={handleImageLoad} style={{
      transform: `scale(${imageScale})`,
      transformOrigin: 'bottom left',
      opacity: imageOpacity
    }} data-id="element-339" />
      <div className="absolute inset-0 flex items-center" data-id="element-340">
        <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-20 w-full relative" data-id="element-341">
          <h1 className="font-light text-white transition-all duration-[1200ms] ease-out absolute" style={{
          fontSize: '2.9rem',
          lineHeight: '1.1',
          opacity: firstQuoteOpacity,
          transform: `scale(${firstQuoteScale})`,
          transformOrigin: 'left center'
        }} data-id="element-342">
            {quotes[0].text.map((line, index) => <span key={index} className="block" data-id="element-343">
                {line}
              </span>)}
          </h1>
          <h1 className="font-light text-white transition-all duration-[1200ms] ease-out" style={{
          fontSize: '2.9rem',
          lineHeight: '1.1',
          opacity: secondQuoteOpacity,
          transform: `scale(${secondQuoteScale})`,
          transformOrigin: 'left center'
        }} data-id="element-344">
            {quotes[1].text.map((line, index) => <span key={index} className="block" data-id="element-345">
                {line}
              </span>)}
          </h1>
        </div>
      </div>
    </section>;
};